

import React, { useState } from 'react';
import {
    IconButton,
    CircularProgress,
    useTheme
} from '@mui/material';

import CheckIcon from '@mui/icons-material/Check';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import NavigationIcon from '@mui/icons-material/Navigation';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

import axios from 'axios';
import config from '../../config';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { CommentTextField } from '../PatientFormContainer/pages/PatientInfoPage/components/CommentTextField';

import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import { WhatAppCommentsDisplay } from './WhatAppCommentsDisplay';
dayjs.extend(relativeTime)




export const supportedWhatAppFileTypes = ['DOCUMENT', 'AUDIO', 'VIDEO', 'VOICE'];

export const statusIcons = {
    failed: <ErrorOutlineIcon sx={{ fontSize: '1.25rem', color: 'red' }} />,
    pending: <CircularProgress size={'1rem'} sx={{ color: 'white' }} />,
    delivered: <CheckIcon sx={{ fontSize: '1.25rem', color: 'white' }} />,
    seen: <DoneAllIcon sx={{ fontSize: '1.25rem', color: 'white' }} />
};


export const WhatsappChatComponent = ({
    selectedChat,
    setsnackbarStatus,
    messageQueryData

}) => {

    const [message, setMessage] = useState('');

    const queryClient = useQueryClient();

    const theme = useTheme();

    const sendMessageMutation = useMutation({
        mutationFn: ({ updaterData }) => {

            return axios.post(
                `${config.API_URL}/operator/whatsAppSend`,
                updaterData,
                { withCredentials: true }
            )

        },
        onSuccess: (data, variables) => {
            queryClient.invalidateQueries({ queryKey: ['messageData'] });

            setMessage('');
        },
        onError: (error, variables) => {
            setsnackbarStatus({ open: true, message: "Failed to Send Message", severity: 'error' })
        }
    });

    const currentChatUser = messageQueryData?.data[selectedChat]?.conversation;

    const handleAddComment = async (e) => {
        e.preventDefault();

        const updaterData = {
            to: currentChatUser,
            content: message,
        };
        sendMessageMutation.mutate({ updaterData });

    };

    const [imageHover, setImageHover] = useState(-1);
    const [position, setPosition] = useState({ x: 0, y: 0 });


    const messagesArray = messageQueryData?.data[selectedChat]?.messages.sort((a, b) => new Date(a.date) - new Date(b.date));



    return (<>

        <div id="portal-root"></div>
        <div className='commentsContainer' style={{
            maxWidth: 'none',
        }}>

            <div key={'commentsDisplay-root'} className='commentsDisplay'>
                <div>
                    {messagesArray && messagesArray?.length > 0 &&
                    <WhatAppCommentsDisplay
                        messagesArray={messagesArray}
                        setImageHover={setImageHover}
                        setPosition={setPosition}
                        imageHover={imageHover}
                        position={position}
                    />}
                </div>

            </div>

            <div className='commentsInput'>

                <CommentTextField
                    id="standard-multiline-comment"
                    variant='standard'
                    multiline
                    rows={4}
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                />

                <div style={{ height: '100%', width: 'auto', display: 'flex', alignItems: 'center' }}>

                    <IconButton
                        onClick={handleAddComment}
                        disabled={sendMessageMutation?.isPending}
                        sx={{

                            background: 'rgb(55, 107, 185)',
                            outline: '2px solid #7ca8c696',
                            '&:hover': {
                                transition: '0.25s ease-in-out', background: 'rgb(125,188,255)'
                            }
                        }}>
                        <NavigationIcon sx={{ transform: 'rotate(90deg)', fontSize: '1.25rem', }} />
                    </IconButton>

                </div>
            </div>


        </div>

    </>)

}




























